import { Responsible, ResponsibleSearch } from 'config/api/workplaces/_types';

const coworkersInitialParser = (formData: Responsible[]): ResponsibleSearch[] =>
  formData.map(({ id, profile }) => ({
    key: id,
    fullName: `${profile?.firstName} ${profile?.lastName}`,
  }));

export default coworkersInitialParser;
